import React, { createContext, useEffect, useState } from "react";
import { PropsType } from "../../interfaces/ChildrenType";
import { DebtResponse } from "../../interfaces/Debt";
import { DebtResultContextType } from "./debt-types";

const DebtData = sessionStorage.getItem("pepper-user-debt");
const initialState: DebtResultContextType = {
  debtResult: JSON.parse(DebtData as string) || undefined,

  setDebtResult: () => { },
};

export const DebtResultContext = createContext(initialState);

export const DebtResultContextProvider: React.FC<PropsType> = ({
  children,
}) => {
  const [debtResult, setDebtResult] = useState<
    DebtResponse | undefined
  >(initialState.debtResult);

  useEffect(() => {
    if (debtResult) {
      sessionStorage.setItem('pepper-user-debt', JSON.stringify(debtResult))
    } else {
      sessionStorage.removeItem("pepper-user-debt");
    }
  }, [debtResult])

  return (
    <DebtResultContext.Provider
      value={{ debtResult, setDebtResult }}
    >
      {children}
    </DebtResultContext.Provider>
  );
};
